<form [formGroup]="form" class="p-0" (ngSubmit)="$event.preventDefault()">
    <div class="low col-4">
        <rask-selector
            class="col-12"
            formControlName="produktId"
            [itemDisabled]="produktInaktiv"
            [placeholder]="'DEFAULT_SELECT_PRODUKT' | translate"
            [search]="searchForProdukt"
            [viewFormatter]="produktFormatter"
            [exclude]="exclude()"
            [rule]="getRule('produktId')"
            [formatter]="produktOutput">
        </rask-selector>
    </div>
    <div class="low col-2">
        <rask-button class="col-3 link-button" color="link" type="button" id="produktlink"
                (click)="navigateToProdukt()" icon="far fa-external-link fa-lg"></rask-button>
        <rask-input-number class="col-9" formControlName="andel" [rule]="validationContext.current.produktAndel" [step]="1" [min]="0" [max]="100"></rask-input-number>
    </div>
    <rask-selector class="low col-2" formControlName="fordelningstyp" [search]="searchFordelningstyper"></rask-selector>

    <div class="col-1">
        <span class="controls">
            <rask-button [disabled]="disabled" color="tertiary" negative type="button" id="produktHandelssortimentRemoveButton"
                (click)="removeHandelssortimentProdukt()" icon="far fa-trash-alt fa-lg"></rask-button>
        </span>
    </div>
</form>
